import React from 'react';

// @mui
import { Button, Dialog, TableCell } from '@mui/material';
import DiffTable from '../../components/diffTable/DiffTable';

export default class GridDiffCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }
    onOpenDiffDialog = () => {
        this.setState({ open: true });
    };
    onCloseDiffDialog = () => {
        this.setState({ open: false });
    };
    render() {
        // props: value, id, field
        let id = this.props.field.id;
        const value = this.props.value;
        if (!value || typeof value !== 'object') {
            return <TableCell align="left">-</TableCell>;
        }
        const baseStyle = this.props.styles;
        return (
            <>
                <TableCell key={id} align="left" sx={{ ...baseStyle }}>
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => {
                            this.onOpenDiffDialog();
                        }}
                    >
                        View Diff
                    </Button>
                </TableCell>
                <Dialog open={this.state.open} onClose={this.onCloseDiffDialog} maxWidth="md" fullWidth>
                    <DiffTable rows={value} />
                </Dialog>
            </>
        );
    }
}
